module.exports = __webpack_public_path__ + "img/member.196fda3e.svg";